import React, { FunctionComponent } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ROUTES } from '../../utils/routes';
import { User } from '../../types/userTypes';
import { DealerLaunchDashboard } from '../DealerLaunchDashboard/DealerLaunchDashboard';
import { SupportPageFrame } from './SupportPageFrame';
import { SupportOverview } from './pages/SupportOverview/SupportOverview';
import { SupportNewDealer } from './pages/SupportNewDealer';
import { SupportViewDealer } from './pages/SupportViewDealer/SupportViewDealer';

type Props = {
  user: User;
};

export const SupportDashboard: FunctionComponent<Props> = ({ user }) => {
  return (
    <SupportPageFrame>
      <Switch>
        <Route path={ROUTES.SUPPORT_DASHBOARD_NEW_DEALER.template}>
          <SupportNewDealer />
        </Route>
        <Route path={ROUTES.SUPPORT_DASHBOARD_VIEW_DEALER.template}>
          <SupportViewDealer />
        </Route>
        <Route path={ROUTES.SUPPORT_DASHBOARD.template}>
          <SupportOverview user={user} />
        </Route>
        <Route path={ROUTES.ADMIN_ACCESS_DEALER.template}>
          <DealerLaunchDashboard showAdminView />
        </Route>
        <Redirect push to={ROUTES.SUPPORT_DASHBOARD.getPath()} />
      </Switch>
    </SupportPageFrame>
  );
};
